export const SuggestionsList = [
  {
    id: "de5e3a0ce050e9cc6cb26ea1",
    userAvatar:
      "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjF8fHByb2ZpbGV8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
    userName: "Tom_Bradon_69",
    worksAt: "Microsoft INC - California",
  },
  {
    id: "e42dcbb5727b9643c4fccbba",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6NaS_x_LUygxvqAt5gQ-sR_3ja_1xhSysSw&usqp=CAU",
    userName: "Stephan62",
    worksAt: "Mohr - Pacocha",
  },
  {
    id: "00ffece47f169fa1aa962dd6",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQSgdDf6PlBrImO0rOQ6Cfm0aLxTOZ2w0MBbw&usqp=CAU",
    userName: "Braden.Rolfson",
    worksAt: "Gerlach - Mills",
  },
  {
    id: "ae4a5fcbf0cbb55dd8040f87",
    userAvatar:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuIqNI4-f9RRe5vielTuDU0w-srV9l9VNsTw&usqp=CAU",
    userName: "Bettie_Torp90",
    worksAt: "Ziemann - Boyle",
  },
  {
    id: "fec8aefe77b3d9dc3afeb2be",
    userAvatar:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8cHJvZmlsZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
    userName: "Jazzy_Fransis",
    worksAt: "Doulis - Russia",
  },
];
